module.exports = new __parcel__URL__("C7S1.aeef2cdd.png").toString();